import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table} from 'react-bootstrap';
import swal from 'sweetalert';
import moment from 'moment';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import {pencil2} from 'react-icons-kit/icomoon/pencil2';
import {search} from 'react-icons-kit/icomoon/search';
import {bin} from 'react-icons-kit/icomoon/bin';
import {priceTag} from 'react-icons-kit/icomoon/priceTag';
import SvgIcon from 'react-icons-kit';
import {droplet} from 'react-icons-kit/icomoon/droplet';
import ModalGrupoRH from '../../offers/components/ModalGrupoRH';
import ModalInfo from './modalInfo';
import ModalPrintLabel from '../../generics/ModalPrintLabel';
import Help from '../../generics/help';

var Config = require('../../../config');

class EntriesList extends Component{
	constructor(props){
		super(props);

		this.getList = this.getList.bind(this);
		this.newEntry = this.newEntry.bind(this);
		this.viewInfo = this.viewInfo.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.editInformation = this.editInformation.bind(this);
		this.deleteEntry = this.deleteEntry.bind(this);

		var aux_date = new Date();

		this.state = {
			entries: [],
			filterText: "",
			start_date 	: aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			end_date 	: aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			start_folio:"",
			end_folio:"",
			preview_print:{},
			columns:[]
		}
	}

	componentDidMount(){
		this.getList();

		this.props.socket.onerror = (event)=> {
			console.log(event);
		};

		this.props.socket.onmessage = (event) => {
			var res = JSON.parse(event.data);
			if(res.Error === "No hay impresora configurada para imprimir")
				swal('¡Error!', res.Error, 'error');
		}

		fetch(Config.default.apiGateway.URL+'list_show?option=list_key&search=EXTERNAL_BAGS',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
      	})
      	.then(response => response.json())
      	.then(response => {
        	if(response !== undefined){
          		this.setState({ columns: response });
        	}
      	});

		//Criterio funcional,cambiar lugar de colecta
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=lab_preview_print&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				preview_print: response
			});
		})
	}

	showColumn(column_name){
      	for(var i =0; i < this.state.columns.length;i++){
  			if(this.state.columns[i]=== column_name){
          		return false;
        	}
      	}

	    return true;
  	}

	getList(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'donations/external_donation?health_facilities_id='+
			sessionStorage.getItem('health_facilities_id')+'&start_date='+this.state.start_date+
			'&end_date='+this.state.end_date+'&start_folio='+this.state.start_folio+'&end_folio='+
			this.state.end_folio,{
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					entries: response
				});
			}
		});
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});
	}

	newEntry(){
		this.props.history.push('/bag_entries/new');
	}

	openModalGrupoRH(e, item){
    	e.preventDefault();
    	var group_test_id = 0;
    	var rh_group = '';
    	if(item.group_test !== null){
    		group_test_id = item.group_test.id;
    		rh_group = item.group_test.group+' '+(item.group_test.RH === 'POSITIVO' ? '+' 
    					: item.group_test.RH === 'NEGATIVO' ? '-' : '');
    	}
      	this.modal_grupo_rh.handleShow(item.offers.donor_id, item.offers.id, group_test_id, rh_group);
  	}

  	openModalLabel(type, id, extraction, print){
    	this.modal_print_label.handleShow(type,id, extraction, print, this.state.preview_print);
  	}

	filter(row){
		var res = true;

		if(row !== null){

			var founding = row.person.names+' '+row.person.lastname1+' '+row.person.lastname2+' '+
							row.donation.donation_number+' '+row.donation_type+' '+row.extraction_type+' '+row.status;

			if(founding.toUpperCase().indexOf(this.state.filterText.toUpperCase()) !== -1){
				res = true;
			}else{
				res = false;
			}
			/*if(
				row.person.names !== null &&
				row.person.lastname1 !== null &&
				row.person.lastname2 !== null &&
				row.donation.donation_number !== null &&
				row.donation_type !== null &&
				row.extraction_type !== null 
			){
				
				if(
					row.person.names.indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.person.lastname1.indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.person.lastname2.indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.donation.donation_number.toString().indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.donation_type.toString().indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.extraction_type.toString().indexOf(this.state.filterText.toUpperCase()) !== -1 
				){
					res = true;
				}else{
					res = false;
				}
			}*/

		}

		return res;
	}

	viewInfo(e, id){
		this.modal_info.handleShow(id);
	}

	editInformation(e, id){
		this.props.history.push('/bag_entries/edit/'+id);
	}

	directPrint(response, label_type){
	    //PRINTER
	    var reader = new FileReader();
	    reader.readAsDataURL(response); 
	    reader.onloadend = ()=> {
	      	var base64data = reader.result;  
	      	var aux = base64data.split(',');
	      	this.props.socket.send('{"Operacion":"print", "Type":"'+label_type+'", "File": "'+aux[1]+'"}');
	    }
	}

	deleteEntry(e, id){
		swal({
	        title: '¿Está seguro?',
	        text: '¿Desea eliminar la entrada?',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: '¡Si, Eliminar!',
	        cancelButtonText: '¡No, Cancelar!',
	        closeOnConfirm: true,
	        closeOnCancel: true
	    }, (isConfirm) => {
	        if (isConfirm) {
	        	this.props.waiting.handleShow('Eliminando...');
	        	fetch(Config.default.apiGateway.URL+'offers/'+id,{ 
		            method: 'delete',
		            headers: new Headers({
		               'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		               'Accept': 'application/json',
		              'Content-Type': 'application/json',
		            })
	         	})
	          	.then(res => {
	          		this.props.waiting.handleClose();
		            if(res.ok){
		              return res.json();
		            }else{
		              res.text().then(function(result) {
		                swal('¡Error!', result, 'error');
		              });
		            }})
	          	.then(res => {
	              	if(res !== undefined){
	                	swal('Buen Trabajo', 'Registro Eliminado','success');
	                	this.getList();
	              	}
	          	});	          	
	        }
	    });
	}

	render(){
		const {t} = this.props;
		var session = sessionStorage.getItem('health_facilities_name');

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{session} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.donors.MAIN')} ->
						Entrada Bolsas Externas
					</h5>
				</div>
				
				<Help 
					{...this.props}
	                menu={"help_donors"} 
	                submenu={"help_ext_bags"}  />

				<form noValidate>
					<div className="col-xs-12">
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Fecha Desde</span>
							<input type="date" className="form-control" name="start_date" id="start_date"
								value={this.state.start_date} onChange={this.handleChange} />
						</div>
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Fecha Hasta</span>
							<input type="date" className="form-control" name="end_date" id="end_date"
								value={this.state.end_date} onChange={this.handleChange} />
						</div>
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Folio Desde</span>
							<input type="text" className="form-control" name="start_folio" id="start_folio"
								value={this.state.start_folio} onChange={this.handleChange} />
						</div>
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Folio Hasta</span>
							<input type="text" className="form-control" name="end_folio" id="end_folio"
								value={this.state.end_folio} onChange={this.handleChange} />
						</div>
						<div className="col-xs-12 col-sm-2" style={{marginTop:"13px"}}>
							<button type="button" className="btn btn-info" onClick={this.getList} style={{fontSize:"14px"}}>
								Buscar
							</button>
							<button type="button" className="btn btn-info" onClick={this.newEntry} 
								style={{fontSize:"14px", marginLeft:"5px"}} disabled={!this.props.task_external_bags.create}>
								Nuevo
							</button>
						</div>
						

					</div>
					<div className="col-xs-12 form-group">
						<div className="col-xs-12 col-sm-2" style={{marginTop:"20px"}}>
							<input type="text" className="form-control" placeholder="Filtro..." name="filterText" 
								id="filterText" value={this.state.filterText} onChange={this.handleChange} />
						</div>
					</div>

					<div className="col-xs-12 form-group">
						<Table responsive hover>
							<thead>
								<tr>
									<th hidden={this.showColumn('DONOR')}>Donador</th>
									<th hidden={this.showColumn('DONATION_NUMBER')}>Número Donación</th>
									<th hidden={this.showColumn('DONATION_TYPE')}>Tipo Donación</th>
									<th hidden={this.showColumn('EXTRACTION_TYPE')}>Tipo Extracción</th>
									<th hidden={this.showColumn('INIT_GROUP')}>Grupo Inicial</th>
									<th hidden={this.showColumn('GROUP_RH')}>Grupo & RH</th>
									<th hidden={this.showColumn('EXTRACTION_DATE')}>Fecha Extracción</th>
									<th hidden={this.showColumn('STATUS')}>Estatus</th>
									<th hidden={this.showColumn('REGISTER_LABEL')}>ET. REG.</th>
									<th hidden={this.showColumn('EXTRACTION_LABEL')}>ET. EXT.</th>
									<th hidden={this.showColumn('CONTROLS')}></th>
								</tr>
							</thead>
							<tbody>
								{this.state.entries.map((e, i)=>{
									return this.filter(e) ?
										<tr key={i} className={e.completed ? "" : "warning"}>
											<td hidden={this.showColumn('DONOR')}>{e.person.lastname1+' '+e.person.lastname2 +' '+e.person.names}</td>
											<td hidden={this.showColumn('DONATION_NUMBER')}>{e.donation.donation_number}</td>
											<td hidden={this.showColumn('DONATION_TYPE')}>{e.donation_type}</td>
											<td hidden={this.showColumn('EXTRACTION_TYPE')}>{e.extraction_type}</td>
											<td hidden={this.showColumn('INIT_GROUP')}>
							                  	<a href="" onClick={(ev) => this.openModalGrupoRH(ev, e)}>
						                    	{e.group_test != null?
						                     		e.group_test.group + (e.group_test.RH === 'POSITIVO' ? '+' : 
						                     			e.group_test.RH === 'NEGATIVO' ? '-' : '')
						                     	:<SvgIcon size={25} icon={droplet} title="Grupo & RH"/>
						                    	}
							                  </a>
											</td>
											<td hidden={this.showColumn('GROUP_RH')}>
						                    	{e.group_rh}
											</td>
											<td hidden={this.showColumn('EXTRACTION_DATE')}>
												{moment(e.offers.timestamp_date, 'YYYY-MM-DD').format('DD/MM/YYYY')+' '}
												{moment(e.offers.timestamp_hour, 'HH:mm').format('HH:mm')}
											</td>
											<td hidden={this.showColumn('STATUS')}>
												{e.status}
											</td>
											<td hidden={this.showColumn('REGISTER_LABEL')}>
												<FloatingActionButton backgroundColor={'#ededed'} iconStyle={{height: 33, width: 33}} title="Registro" 
													mini={true} style={{marginLeft:"5px"}} 
													onClick={this.openModalLabel.bind(this,'label_register', e.offers.id, null, true)}>
							                        <SvgIcon icon={priceTag} className="icon-align"/>
							                    </FloatingActionButton>
											</td>
											<td hidden={this.showColumn('EXTRACTION_LABEL')}>
												<FloatingActionButton backgroundColor={'#ededed'} iconStyle={{height: 33, width: 33}} title="Extracción" mini={true} 
							                        style={{marginLeft:"5px"}} 
							                        onClick={this.openModalLabel.bind(this,"label_extraction", e.donation.id, e.extraction_type, true)}>
							                        <SvgIcon icon={priceTag} className="icon-align"/>
							                    </FloatingActionButton>
											</td>
											<td hidden={this.showColumn('CONTROLS')} width="140">
												<FloatingActionButton backgroundColor={'#ededed'} mini={true} style={{marginLeft:"5px"}} 
													iconStyle={{height: 33, width: 33}} onClick={(ev)=>this.viewInfo(ev, e.donation.id)}>
													<SvgIcon icon={search} className="icon-align"/>
												</FloatingActionButton>
												
						                    	<FloatingActionButton backgroundColor={'#ededed'} mini={true} style={{marginLeft:"5px"}} 
													iconStyle={{height: 33, width: 33}}
												 	onClick={(ev)=>this.editInformation(ev, e.donation.id)}
												 	disabled={this.props.task_external_bags.update ?
												 		false
												 	: true}>
													<SvgIcon icon={pencil2} disabled={!this.props.task_external_bags.update} className="icon-align"/>
												</FloatingActionButton>

												<FloatingActionButton backgroundColor={'#ededed'} mini={true} style={{marginLeft:"5px"}} 
													iconStyle={{height: 33, width: 33}}
												 	onClick={(ev)=>this.deleteEntry(ev, e.offers.id)}
												 	disabled={!this.props.task_external_bags.delete}>
													<SvgIcon icon={bin} disabled={!this.props.task_external_bags.delete} 
														className="icon-align"/>
												</FloatingActionButton>
											</td>
										</tr>
									:null
								})}
							</tbody>
						</Table>
					</div>
				</form>
				<ModalGrupoRH {...this.props} onRef={ref => (this.modal_grupo_rh = ref)} refresh={this.getList}/>
				<ModalInfo {...this.props} onRef={ref => (this.modal_info = ref)} />
				<ModalPrintLabel {...this.props} onRef={ref => (this.modal_print_label = ref)} directPrint={this.directPrint}/>
			</div>
		)
	}
}



export default translate('translations') (EntriesList);